<template>
    <div>
        <div class="modal hide fade" id="modalSalesByNo" tabindex="-1" role="dialog" aria-labelledby="modalSaleOrderByNo" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Sale {{ sale.sale_no }}
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <dl class="row">
                                    <dd class="col-sm-4"><strong>Sales:</strong></dd>
                                    <dd class="col-sm-8"></dd>

                                    <dd class="col-sm-4">Outstanding</dd>
                                    <dd class="col-sm-8">
                                        <span v-if="totalOutstanding === 0" class="badge badge-success">Lunas</span>
                                        <span v-else>{{ totalOutstanding | currency}}</span>
                                    </dd>

                                    <dd class="col-md-4">Sale No.</dd>
                                    <dd class="col-md-8"><b>{{ sale.sale_no }}</b></dd>

                                    <dd class="col-md-4">Company</dd>
                                    <dd class="col-md-8"><b>{{ sale.company }}</b></dd>

                                    <dd class="col-md-4">Tanggal</dd>
                                    <dd class="col-md-8">{{ sale.sale_date | dateFormat('DD/MM/YYYY') }}</dd>

                                    <dd class="col-md-4">Jatuh Tempo</dd>
                                    <dd class="col-md-8">{{ sale.sale_due_date | dateFormat('DD/MM/YYYY') }}</dd>

                                    <dd class="col-md-4">Salesman</dd>
                                    <dd class="col-md-8">{{ sale.salesman }}</dd>

                                    <dd class="col-md-4">Sales Group</dd>
                                    <dd class="col-md-8">{{ sale.supervisor }}</dd>

                                    <dd class="col-md-4">Tanda Terima</dd>
                                    <dd class="col-md-8"><span v-if="sale.check_tanda_terima === true" style="color: green;"><i class="fa fa-check"></i></span></dd>

                                    <dd class="col-md-4">Notes</dd>
                                    <dd class="col-md-8">{{ sale.notes }}</dd>
                                </dl>
                            </div>
                            <div class="col-md-6">
                                <dl class="row">
                                    <dd class="col-sm-4"><strong>Customer:</strong></dd>
                                    <dd class="col-sm-8"></dd>

                                    <dd class="col-md-4">Name</dd>
                                    <dd class="col-md-8">{{ dataCustomer.name }}</dd>

                                    <dd class="col-md-4">Phone</dd>
                                    <dd class="col-md-8">{{ dataCustomer.phone }}</dd>

                                    <dd class="col-md-4">Address</dd>
                                    <dd class="col-md-8">{{ dataCustomer.address }}</dd>
                                </dl>
                            </div>
                        </div>
                        <hr>

                        <div class="row">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs nav-bordered">
                                    <li class="nav-item">
                                      <a href="#sales-tab-modal" data-toggle="tab" aria-expanded="false" class="nav-link active">Sales</a>
                                    </li>
                                    <li class="nav-item">
                                      <a href="#payment-tab-modal" data-toggle="tab" aria-expanded="false" class="nav-link">Payment</a>
                                    </li>
                                    <li class="nav-item">
                                      <a href="#retur-tab-modal" data-toggle="tab" aria-expanded="false" class="nav-link">Retur</a>
                                    </li>
                                    <li class="nav-item">
                                      <a href="#payment-komisi" data-toggle="tab" aria-expanded="false" class="nav-link">Komisi</a>
                                    </li>
                                    <li class="nav-item">
                                      <a href="#journal-tab-modal" data-toggle="tab" aria-expanded="false" class="nav-link">Journal</a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div class="tab-pane active" id="sales-tab-modal">
                                        <div class="table-responsive">
                                            <table class="table table-item table-sm table-hover table-striped">
                                                <thead>
                                                    <th>Product</th>
                                                    <th>Qty</th>
                                                    <th>Uom</th>
                                                    <th class="text-right">Price</th>
                                                    <th class="text-right">Disc</th>
                                                    <th class="text-right">Tax</th>
                                                    <th class="text-right">Total</th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="d in sale.details" :key="d.id">
                                                        <td><b>[{{ d.product_no }}]</b> {{ d.description }}</td>
                                                        <td>{{ d.qty }}</td>
                                                        <td>{{ d.uom_id }}</td>
                                                        <td class="text-right">{{ d.price | currency }}</td>
                                                        <td class="text-right">{{ d.discount | currency }}</td>
                                                        <td class="text-right">{{ d.tax | currency }}</td>
                                                        <td class="text-right">{{ d.total | currency }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="7"></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td><b>Subtotal</b></td>
                                                        <td class="text-right">{{ sale.subtotal | currency}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td><b>Discount</b></td>
                                                        <td class="text-right">{{ sale.discount | currency }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td><b>Tax</b></td>
                                                        <td class="text-right">{{ sale.tax | currency }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td><b>Total</b></td>
                                                        <td class="text-right">{{ sale.total | currency }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="payment-tab-modal">
                                        <div class="table-responsive">
                                            <table class="table table-sm table-item table-striped">
                                                <thead>
                                                    <th>Group</th>
                                                    <th>Payment No.</th>
                                                    <th>Date</th>
                                                    <th>Method</th>
                                                    <th>Account</th>
                                                    <th>Note</th>
                                                    <th>Amount</th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="p in sale.payments" :key="p.id">
                                                        <td>{{ p.group_no }}</td>
                                                        <td>{{ p.payment_no }}</td>
                                                        <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                                        <td>{{ p.method }}</td>
                                                        <td>{{ p.account }}</td>
                                                        <td>{{ p.notes }}</td>
                                                        <td>{{ p.price | currency }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>{{ totalSalePayment | currency }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="retur-tab-modal">
                                        <div class="table-responsive">
                                            <table class="table table-sm table-item table-striped">
                                            <thead>
                                                <th>Return no</th>
                                                <th>Return Date</th>
                                                <th>Product No.</th>
                                                <th>Product</th>
                                                <th>Qty</th>
                                                <th class="text-right">Amount</th>
                                                <th>Tax</th>
                                                <th class="text-right">Total</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="r in dataReturn" :key="r.id">
                                                <td>{{ r.return_no }}</td>
                                                <td>{{ r.return_date | dateFormat('DD/MM/YYYY') }}</td>
                                                <td>{{ r.product_no }}</td>
                                                <td>{{ r.product }}</td>
                                                <td>{{ r.qty }}</td>
                                                <td class="text-right">{{ r.amount | currency }}</td>
                                                <td>{{ r.tax }} ({{ r.taxes }})</td>
                                                <td class="text-right">{{ r.total | currency }}</td>
                                                </tr>
                                                <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td class="text-right">{{ totalReturn | currency }}</td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="payment-komisi">
                                      <div class="table-responsive">
                                          <table class="table table-sm table-item table-striped">
                                            <thead>
                                              <th>Payment No.</th>
                                              <th>Commission</th>
                                              <th>Percentage %</th>
                                              <th>Amount</th>
                                            </thead>
                                            <tbody>
                                              <tr v-for="(k, kid) in sale.commissions" :key="kid">
                                                <td>{{ k.payment_no }}</td>
                                                <td>{{ k.commission }}</td>
                                                <td>{{ k.commission_percentage }}</td>
                                                <td>{{ k.commission_amount | currency }}</td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="journal-tab-modal">
                                      <div class="table-responsive">
                                        <table class="table table-sm table-item table-hover table-striped">
                                          <thead>
                                            <th>Journal Code</th>
                                            <th>Date</th>
                                            <th>Account Code</th>
                                            <th>Remark</th>
                                            <th class="text-right">Debit</th>
                                            <th class="text-right">Credit</th>
                                          </thead>
                                          <tbody>
                                            <tr v-for="j in sale.journals" :key="j.id">
                                              <td>
                                                <span v-if="j.level === 1">
                                                  <b>{{ j.journal_code }} - {{ j.journal_description }}</b>&nbsp;
                                                  <span class="badge badge-success" v-if="j.status === 'posted'">{{ j.status }}</span>
                                                  <span class="badge badge-warning" v-else-if="j.status === 'draft'">{{ j.status }}</span>
                                                </span>
                                                <span v-else></span>
                                              </td>
                                              <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                                              <td><b>{{ j.account_code }} {{ j.account }}</b></td>
                                              <td>{{ j.remark }}</td>
                                              <td class="text-right">
                                                <span v-if="j.level === 2">{{ j.debit | currency }}</span>
                                                <span v-if="j.level === 3"><b>{{ j.debit | currency }}</b></span>
                                                <span v-else></span>
                                              </td>
                                              <td class="text-right">
                                                <span v-if="j.level === 2">{{ j.credit | currency }}</span>
                                                <span v-if="j.level === 3"><b>{{ j.credit | currency }}</b></span>
                                                <span v-else></span>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <pre>{{ sale }}</pre> -->
                    </div>
                    <!-- <div class="modal-footer"><button class="btn btn-primary btn-sm pull-right" @click="setJournal">Set Journal</button></div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { salesUrl, getHeader } from '@/config'
export default {
  name: 'SaleModal',
  computed: {
    ...mapState({
      sale: state => state.sales.sale
    }),
    totalReturn () {
      var sum = 0
      var array = this.dataReturn
      for (let a = 0; a < array.length; a++) {
        sum += parseFloat(array[a].total)
      }
      return sum
    },
    dataReturn () {
      var loop = []
      if (this.sale.returs) {
        loop = this.sale.returs[0].details
      }
      return loop
    },
    totalOutstanding () {
      var sum = 0
      sum = this.sale.total - this.totalReturn - this.totalSalePayment
      return sum
    },
    totalSalePayment () {
      var sum = 0
      if (this.sale.payments.length > 0) {
        var array = this.sale.payments.filter(d => d.id !== null)
        if (array.length > 0) {
          for (let i = 0; i < array.length; i++) {
            sum += parseFloat(array[i].price)
          }
        }
      }
      return sum
    },
    dataCustomer () {
      var customer = this.sale.customer
      var obj
      if (typeof customer === 'undefined') {
        obj = {
          name: null,
          phone: null,
          address: null
        }
      } else {
        obj = {
          name: customer.name,
          phone: customer.phone,
          address: customer.address
        }
      }
      return obj
    }
  },
  methods: {
    async setJournal () {
      await axios.get(salesUrl + '/journal/' + this.sale.id, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async setJournalStockOut () {
      await axios.get(salesUrl + '/journal-stock-out/' + this.sale.id, { headers: getHeader() })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    }
  }
}
</script>
